import { BuildFontString } from "./BuildFontString";
import { SVG_DrawRect } from "./SVG_DrawRect";
import { SVG_DrawText } from "./SVG_DrawText";
import { MeasureText } from "./MeasureText";

export function SVG_DrawLegend(
  chartX,
  chartY,
  maxWidth,
  height,
  radius,
  pieSections,
  altCanvasElement
) {
  var sy = Math.ceil(Math.floor(height * 0.45) + 1.05 * radius);
  var remainingHeight = height - sy;
  var numlevels = Math.ceil(pieSections.length / 3);
  var boxDim = Math.min(Math.floor((remainingHeight - 6) / numlevels), 14);
  var curX = chartX - radius;
  var curY = chartY + radius + 2;
  for (var sectionIdx in pieSections) {
    var curSection = pieSections[sectionIdx];
    var color = curSection["color"];
    var value = curSection["value"];

    SVG_DrawRect(curX, curY, boxDim, boxDim, color, color, altCanvasElement);
    SVG_DrawText(
      value,
      curX + boxDim + 3,
      curY + boxDim,
      "black",
      "Tahoma",
      boxDim,
      false,
      false,
      false,
      "left",
      "bottom",
      false,
      altCanvasElement
    );
    var fs = BuildFontString("Tahoma", boxDim, false, false);
    var nextX = curX + MeasureText(value, fs) + boxDim + 2;
    if (nextX > chartX + radius) {
      curX = chartX - radius;
      curY += boxDim + 6;
    } else curX = nextX + 6;
  }
}
